<template>
  <div class="login">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <h3>修改密码</h3>
      <p>国家:</p>
      <!-- <el-form-item label="" prop="country">
        <el-input v-model.number="ruleForm.country"></el-input>
      </el-form-item>
      <p>手机号:</p>
      <el-form-item label="" prop="id">
        <el-input v-model.number="ruleForm.id"></el-input>
      </el-form-item> -->
      <el-form-item label="" prop="phone">
        <el-phone-number-input v-model="ruleForm.phone"></el-phone-number-input>
      </el-form-item>
      <p>短信验证码:</p>
      <el-form-item class="yzm" label="" prop="dxpass">
        <el-input
          type="password"
          v-model="ruleForm.dxpass"
          autocomplete="off"
        ></el-input>
        <el-button type="primary" @click="getCode()">获取验证码</el-button>
      </el-form-item>
      <p>密码:</p>
      <el-form-item label="" prop="pass">
        <el-input
          type="password"
          v-model="ruleForm.pass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <p>确认密码:</p>
      <el-form-item label="" prop="checkPass">
        <el-input
          type="password"
          v-model="ruleForm.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确认</el-button
        >
      </el-form-item>
      <div class="foot">
        <div class="fleft">
          <p>已有账号?</p>
          <router-link to="/login">登录</router-link>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { checkAges, validateNewPass, validCheckPass } from '@/utils/validate.js'
import { ElPhoneNumberInput } from 'el-phone-number-input'
export default {
  components: {
    ElPhoneNumberInput
  },
  data() {
    // 短信验证码
    const dxpass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码 不能为空'))
      }
    }
    return {
      phone: {
        callingCode: '',
        phoneNumber: ''
      },
      ruleForm: {
        pass: '',
        checkPass: '',
        id: '',
        dxpass: '',
        phone: {
          callingCode: '',
          phoneNumber: ''
        }
      },
      rules: {
        phone: [{ validator: checkAges, trigger: 'blur' }],
        dxpass: [{ validator: dxpass, trigger: 'blur' }],
        pass: [{ validator: validateNewPass('新密码', this), trigger: 'blur' }],
        checkPass: [
          { validator: validCheckPass('确认密码', this), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  height: 570px;
  background-color: #2c374a;
  // background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);

  padding-top: 75px;
  .el-form {
    position: absolute;
    top: 8%;
    left: 50%;
    transform: translateX(-50%);
    // margin: auto;
    padding: 24px 48px;
    width: 500px;
    height: 570px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    h3 {
      text-align: center;
      font-size: 20px;
      margin-bottom: 40px;
      color: #333;
    }
    p {
      font-size: 14px;
      color: rgb(40, 65, 65);
      text-indent: 1em;
    }
    /deep/.el-form-item {
      width: 400px;
      height: 40px;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
    .yzm {
      .el-input {
        width: 280px;
      }
      .el-button {
        width: 120px;
      }
    }
    .el-button {
      width: 400px;
    }
    .foot {
      display: flex;
      justify-content: space-between;
      .fleft {
        display: flex;
      }
      a {
        color: #276ff4;
      }
    }
  }
}
</style>
